// Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);

// Store
const fuente = new vapi({
    namespaced : true,
    baseURL: `${process.env.VUE_APP_REST}/api/fuente`,    
    state: {
        fuentes: []
    }
})
.get({
    action: "get_fuentes",   
    onSuccess: (state, payload) => {        
        state.fuentes = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.fuentes = []
    }    
}).post({
    action: "post_fuente",   
    onSuccess: (state, payload) => {        
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }    
}).put({
    action: "put_fuente",   
    onSuccess: (state, payload) => {        
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);       
    }    
}).delete({
    action: "delete_fuente",   
    path: function (obj) {
        return `${obj.idfuente}`
    },
    onSuccess: (state, payload) => {        
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);       
    }    
}).getStore();

fuente.getters = {  
    gfuentes : state =>  {
        return state.fuentes
    }
}
export default fuente;
